export const getSortedJsonWrtDates = (jsonArray) => {
  try {
    let arrayWithSlashDateString = jsonArray.map((ele) => {
      let Dates = ele.date.split("-").join("/");
      return { ...ele, newDate: Dates };
    });

    let arrayWithDatesDesc = arrayWithSlashDateString.sort((a, b) => {
      return Date.parse(b.newDate) - Date.parse(a.newDate);
    });

    return arrayWithDatesDesc;
  } catch (e) {
    console.log("Error in getSortedJsonWrtDates: ", e);
    return [];
  }
};

export const FormatChanger = (date) => {
  let modifiedDate = date.split("-").join("/");
  let d = new Date(modifiedDate);
  let convertedDate =
    d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
  return convertedDate;
};

export const handleCustomArrowClick = (
  e,
  arrowType,
  sectionIndexOnPage = 0
) => {
  e.preventDefault();
  const domInbuiltArrowName = arrowType === "Next" ? "right" : "left";
  const inbuiltArrow = document.querySelectorAll(
    ".react-multiple-carousel__arrow.react-multiple-carousel__arrow--" +
      domInbuiltArrowName
  );

  if (inbuiltArrow && inbuiltArrow.length === 1) {
    inbuiltArrow[sectionIndexOnPage].click();
  }
};

/** Function to differentiate between a normal click and a drag */
export const handleMouseUp = (e, clickPosition = 0, callBack) => {
  if (e.clientX - clickPosition === 0) {
    callBack();
  }
};
